document.addEventListener("DOMContentLoaded", function () {
  const config = window.VariantImageFilter || {};
  const gallery = document.querySelector(".product__media-list") || document.querySelector("#MediaGallery");
  if (!gallery) return;

  function normalize(str) {
    return (str || "").toLowerCase().trim();
  }

  function getSelectedColor() {
    // Radio buttons for color variants
    const radios = document.querySelectorAll(`input[name="${config.colorOptionName}"]:checked`);
    if (radios.length) return radios[0].value;

    // Dropdown for color variants
    const select = document.querySelector(`select[name="options[${config.colorOptionName}]"]`);
    return select ? select.value : null;
  }

  function filterImages() {
    const selectedColor = normalize(getSelectedColor());
    if (!selectedColor) return;

    // Find all gallery items
    const items = gallery.querySelectorAll("li, div[data-media-id]");

    items.forEach((item) => {
      const img = item.querySelector("img");
      if (!img) return;

      const alt = normalize(img.alt);
      const src = normalize(img.src);

      // Show only matching images, hide others
      if (alt.includes(selectedColor) || src.includes(selectedColor)) {
        item.style.display = "";
        item.style.opacity = "1";
      } else {
        item.style.display = "none";
        item.style.opacity = "0";
      }
    });
  }

  // Initial filtering on page load
  filterImages();

  // When user changes variant using radio buttons
  document.addEventListener("change", function (e) {
    if (e.target.name === config.colorOptionName || e.target.name === `options[${config.colorOptionName}]`) {
      filterImages();
    }
  });

  // Listen to Shopify's built-in variant change event
  document.addEventListener("variant:change", filterImages);
});